// Local RBAC vocabulary for admin-web-client.
//
// Mirrors @surecompanies/contracts/rbac (RbacActions / RbacSubjects), but kept
// LOCAL because the published contracts version this app installs does not yet
// expose the `./rbac` subpath. The VALUES are the exact wire strings — identical
// to the DB rows, the /me/ability payload, and the EPS guard — so there is no
// translation anywhere; this is ergonomics (autocomplete + no magic strings)
// only.
//
// When the contracts package ships the `./rbac` subpath and this app bumps to
// it, replace these with imports from '@surecompanies/contracts/rbac' and delete
// this file. Until then, keep the values in sync with that package.

export const RbacActions = {
  Manage: 'Manage',
  Read: 'Read',
  Write: 'Write',
  Download: 'Download',
  TestMode: 'TestMode',
  Access: 'Access',
  Draw: 'Draw',
} as const

export const RbacSubjects = {
  FundingInvoice: 'FundingInvoice',
  AdminPortal: 'AdminPortal',
  Settings: 'Settings',
  PermissionManagement: 'PermissionManagement',
  BillingProfile: 'BillingProfile',
  InvoiceManagement: 'InvoiceManagement',
  OnboardingUser: 'OnboardingUser',
  PaymentReconciliation: 'PaymentReconciliation',
  FundingDraw: 'FundingDraw',
  UserPermission: 'UserPermission',
  UsRestrictedData: 'UsRestrictedData',
} as const

export type RbacAction = (typeof RbacActions)[keyof typeof RbacActions]
export type RbacSubject = (typeof RbacSubjects)[keyof typeof RbacSubjects]
